/* eslint-disable import/prefer-default-export */
const defaultObj = {};

export const getCustomerDetails = (state) => state.GetCustomerDetails?.customerDetails?.payload || defaultObj;
export const getRetryPayment = (state) => state.RetryPayment || defaultObj;
